import { createZodDto } from './zod';

import { z } from 'zod';

// Passive GPS capture, sent as its own request decoupled from whichever field
// action (inspection, NFC scan, ...) triggered it — geolocation can take
// several seconds to resolve and must never block that action.
const RecordEquipmentLocationSchema = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  accuracy: z.number().positive().optional(),
  source: z.enum(['INSPECTION', 'SCAN']),
});

export class RecordEquipmentLocationDto extends createZodDto(
  RecordEquipmentLocationSchema,
) {}
